/**
 * App component (app.component.ts).
 *
 * @version
 * 4.71.0 OAUI-693 Tidy and remove duplicated code
 * 4.71.0 OAUI-682 Rebuild list work/lookahead orders page and improve usability
 * 4.70.0 OAUI-678 Build "Driver Assignment" UI
 * 4.68.0 DEVOPS-928 Add environment route resolver to all Angular repos
 * 4.63.0 DEVOPS-715 order-admin-ui: setup new repo without vertical slicing
 * 4.37.0 OAUI-527 Slowdowns in order modals
 * 4.33.0 OAUI-468 Remove duplicate calls for constants and hostConfiguration
 * 4.26.0 OAUI-416 Add basic QR code order management route
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021-2024 Build Centrix
 */

import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
} from '@angular/core';
import { WdLocalEnvironmentService } from './services/environment/wd-local-environment.service';
import { IEnvironmentModel } from './interfaces/environment/environment-interfaces';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements AfterContentInit {
  // Environment / User
  environmentValues: IEnvironmentModel;
  userInformation: any;

  // Booleans
  isInitialized = false;

  /**
   * Constructor
   * @since 4.68.0
   */
  constructor(public environment: WdLocalEnvironmentService) {}

  /**
   * Handle environment subscriptions
   *
   * @since 1.0.0
   * @memberof AppComponent
   */
  ngAfterContentInit() {
    // Set initialized environment values
    this.environmentValues = this.environment.values;
    this.userInformation = this.environment.values.user.getInformation();
    // https://www.codeandweb.com/babeledit/tutorials/how-to-translate-your-angular-app-with-ngx-translate
    this.isInitialized = this.environment.isInitialized.value;
  }
}

// EOF
